import { render, staticRenderFns } from "./BitmovinPlayer.vue?vue&type=template&id=4f481769&scoped=true"
import script from "./BitmovinPlayer.vue?vue&type=script&lang=js"
export * from "./BitmovinPlayer.vue?vue&type=script&lang=js"
import style0 from "./BitmovinPlayer.vue?vue&type=style&index=0&id=4f481769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f481769",
  null
  
)

export default component.exports